import getImageSize from './get-image-size';
/**
 * @callback imageValidCondition
 * @param {number} width
 * @param {number} height
 * @return {boolean} is image meets the conditions
 */
type imageValidCondition = (width: number, height: number) => boolean;
/**
 * Determine if the image file's width and height meet the conditions and return Promise
 * @module utils/image-size-valid
 * @param {File} file - image file
 * @param {condition} condition
 * @return {Promise} Promise.resolve() or Promise.reject({ width, height })
 */
export default (file: File, condition: imageValidCondition) => {
  return getImageSize(file).then(({ width, height }) => {
    if (condition(width, height)) {
      return Promise.resolve();
    } else {
      return Promise.reject({ width, height });
    }
  });
};
